module.exports = "<div class=\"page-routing\" style=\"width: 100%;height: 2px;position: fixed !important;z-index: 999999 !important;top:0\" *ngIf=\"isRouting\"></div>\n<router-outlet></router-outlet>\n<simple-notifications [options]=\"\n{\nposition: ['bottom', 'right'],\nlastOnBottom: true,\nshowProgressBar: true,\npauseOnHover: true,\nclickToClose: true,\nmaxLength: 100,\nmaxStack:8,\nanimate: 'fromRight',\ntimeOut: 3000\n}\">\n</simple-notifications>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main